// extracted by mini-css-extract-plugin
export default {"form":"styles_form__8TZRR","footer":"styles_footer__WOYTQ","spacer":"styles_spacer__s3Rwn"};